import {
    ICountryData,
    IHowHeardData,
    IProfessionData,
    ISpecialtyData,
    IStateData,
    ISupportRequestGroup,
    ITimezonesData,
    IZipLocationsData,
} from '@/types/types';
import { makeFetcher } from '@/utils/fetch';
import { config } from '@/config';
import { ISurveyBadge } from '@/types/types/forms/survey/survey.interface';

const makeDictionaryService = (apiUrl: string, regstrationApiUrl: string) => {
    const fetcher = makeFetcher(apiUrl);
    const registrationFetcher = makeFetcher(regstrationApiUrl);

    return {
        getCountries: async (): Promise<ICountryData[]> => {
            const res = await fetcher.get(`/countries`, { disableRedirects: true });
            const { data } = (await res.json()) as { data: ICountryData[] };
            const filteredData = data.filter((item) => item.countryCode !== 'RUS');
            return filteredData;
        },
        getStates: async (countryCode: string): Promise<IStateData[]> => {
            const res = await fetcher.get(`/states?countrycode=${countryCode}`, {
                disableRedirects: true,
            });
            const { data } = (await res.json()) as { data: IStateData[] };
            return data;
        },
        getProfessions: async (): Promise<IProfessionData[]> => {
            const res = await fetcher.get(`/professions`, { disableRedirects: true });
            const { data } = (await res.json()) as { data: IProfessionData[] };
            return data;
        },
        getSpecialties: async (): Promise<ISpecialtyData[]> => {
            const res = await fetcher.get(`/specialties`, { disableRedirects: true });
            const { data } = (await res.json()) as { data: ISpecialtyData[] };
            return data;
        },
        getHowHeardList: async (): Promise<IHowHeardData[]> => {
            const res = await registrationFetcher.get(`/sources`, { disableRedirects: true });
            const { data } = (await res.json()) as { data: IHowHeardData[] };
            return data;
        },
        getTimezones: async (): Promise<ITimezonesData[]> => {
            const res = await fetcher.get(`/timezones`, { disableRedirects: true });
            const { data } = (await res.json()) as { data: ITimezonesData[] };
            return data;
        },
        getSurveyBadges: async (): Promise<ISurveyBadge[]> => {
            const res = await fetcher.get(`/survey-badges`, { disableRedirects: true });
            const { data } = (await res.json()) as { data: ISurveyBadge[] };
            return data;
        },
        getSupportRequestTypes: async (): Promise<ISupportRequestGroup[]> => {
            const res = await fetcher.get('/support-request-types', { disableRedirects: true });
            const { data } = (await res.json()) as { data: ISupportRequestGroup[] };
            return data;
        },
        getZipLocations: async (countryCode: string, zip: string): Promise<IZipLocationsData[]> => {
            const res = await fetcher.get(`/zip-location?countryCode=${countryCode}&zip=${zip}`, {
                disableRedirects: true,
            });
            const { data } = (await res.json()) as { data: IZipLocationsData[] };
            return data;
        },
    };
};

export const dictionaryService = makeDictionaryService(
    config.api.url.dictionary,
    config.api.url.registration,
);
